import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/home/dashboard/Dashboard'
import StartPage from '@/views/StartPage.vue'
import Login from '@/views/login/LoginMulti'
import LoginInitial from '@/views/login/initial-login/LoginInitial'
import LoginForgottenPassword from '@/views/login/forgotten-password/LoginForgottenPassword'
import Activation from '@/views/activation/Activation'
import Reset from '@/views/activation/Reset'
import Home from '@/views/home/Home'
import NotFound from '@/views/home/NotFound'
import RegisterAccount from '@/views/account/register/RegisterAccount'
import ValidateAccount from '@/views/account/validate/ValidateAccount'
import ReportIssue from '@/views/issue/ReportIssue'
// import ReportIssuePlaceholder from '@/views/issue/Placeholder/IssuePlaceholder'
import ReviewSystemUsers from '@/views/home/administration/system-users/review-system-users/ReviewSystemUsers'
import SystemUserDetails from '@/views/home/administration/system-users/system-user-details/SystemUserDetails'
import CreateSystemUser from '@/views/home/administration/system-users/create-system-user/CreateSystemUser'
import CreateSystemUsers from '@/views/home/administration/system-users/create-system-users/CreateSystemUsers'
import ReviewUsers from '@/views/home/subsidy/user/review-users/ReviewUsers'
import ReviewBeneficiary from '@/views/home/subsidy/user/review-beneficiary/ReviewBeneficiary'
import ReviewBeneficiaries from '@/views/home/subsidy/user/review-beneficiaries/ReviewBeneficiaries'
import UserDetails from '@/views/home/subsidy/user/review-users/user-details/UserDetails'
import ReviewValidUser from '@/views/home/subsidy/user/review-valid-user/ReviewValidUser'
import ReviewUser from '@/views/home/subsidy/user/review-user/ReviewUser'
import GeneratePaymentOrders from '@/views/home/payment/payment-orders/GenerateOrders'
import SubsidyReport from '@/views/home/report/subsidy/SubsidyReport'
import MinistryReport from '@/views/home/report/ministry/MinistryReport'
import IssueReport from '@/views/home/report/issue/IssueReport'
import ReviewIssues from '@/views/home/issue/review/ReviewIssues'
import IssueDetails from '@/views/home/issue/details/IssueDetails'
import i18n from '@/i18n'
import { accessTokenValid, refreshTokenValid, refreshToken } from './auth'

const $t = i18n.messages[i18n.locale]

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'StartPage',
    component: StartPage,
    meta: {
      title: 'Почетна'
    }
  },
  {
    name: 'register-account',
    path: '/prijava',
    component: RegisterAccount
  },
  {
    name: 'validate-account',
    path: '/provera',
    component: ValidateAccount
  },
  {
    name: 'report-issue',
    path: '/reklamacije',
    component: ReportIssue
  },
  {
    name: 'login-multi',
    path: '/login',
    component: Login,
    meta: {
      title: $t.login.title
    }
  },
  {
    name: 'login-initial',
    path: '/login/initial',
    component: LoginInitial,
    meta: {
      title: $t.login.title
    }
  },
  {
    name: 'forgotten-password',
    path: '/login/password-reset',
    component: LoginForgottenPassword,
    meta: {
      title: $t.login.forgottenPassword
    }
  },
  {
    name: 'activation',
    path: '/activation',
    component: Activation
  },
  {
    name: 'reset',
    path: '/reset-password',
    component: Reset
  },
  {
    path: '/',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'dashboard'
      },
      {
        path: 'administration/system-users',
        component: ReviewSystemUsers,
        name: 'manageSystemUsers'
      },
      {
        path: 'administration/system-users/create-users',
        component: CreateSystemUsers,
        name: 'registerSystemUsers'
      },
      {
        path: 'administration/system-users/create-user',
        component: CreateSystemUser,
        name: 'registerSystemUser'
      },
      {
        path: 'administration/system-users/:userId',
        component: SystemUserDetails,
        name: 'user-details'
      },
      {
        path: 'subsidy/user/review-valid-user',
        component: ReviewValidUser,
        name: 'reviewValidUser'
      },
      {
        path: 'subsidy/user/review-beneficiary',
        component: ReviewBeneficiary,
        name: 'reviewBeneficiary'
      },
      {
        path: 'subsidy/user/review-beneficiaries',
        component: ReviewBeneficiaries,
        name: 'reviewBeneficiaries'
      },
      {
        path: 'subsidy/user/review-anonymous-user',
        component: ReviewUser,
        name: 'reviewUser'
      },
      {
        path: 'subsidy/user/paged-users',
        component: ReviewUsers,
        name: 'reviewUsers'
      },
      {
        path: 'subsidy/user/:userId',
        component: UserDetails,
        name: 'userDetails'
      },
      {
        path: 'payments/generate-orders',
        component: GeneratePaymentOrders,
        name: 'generateOrders'
      },
      {
        path: 'reports/subsidy',
        component: SubsidyReport,
        name: 'subsidyReport'
      },
      {
        path: 'reports/ministry',
        component: MinistryReport,
        name: 'ministryReport'
      },
      {
        path: 'reports/issue',
        component: IssueReport,
        name: 'issueReport'
      },
      {
        path: 'issue',
        component: ReviewIssues,
        name: 'reviewIssues'
      },
      {
        path: 'issue/details/:issueId',
        component: IssueDetails,
        name: 'issueDetails'
      }
    ]
  },
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: NotFound,
    meta: {
      requiresAuth: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // EventBus.$emit('page-change')

  // Site title
  const siteName = $t.title
  let pageName

  if (to.name === 'start-page') {
    pageName = siteName
  } else {
    pageName = to.meta.title ? to.meta.title + ' - ' + siteName : siteName
  }

  document.title = pageName

  // if (!to.matched.length) {
  //   next('/not-found')
  // }
  const isDevelopmentEnvironment = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'pmiproduction'
  // Authorization
  if (isDevelopmentEnvironment) {
    console.log('Executing authorization guard for ' + to.path)
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!accessTokenValid()) {
      if (!refreshTokenValid()) {
        if (isDevelopmentEnvironment) { console.log('Tokens expired - routing not authorized') }
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        if (isDevelopmentEnvironment) { console.log('Refreshing access token') }
        refreshToken(to, from, next)
      }
    } else {
      if (isDevelopmentEnvironment) { console.log('Routing authorized for ' + to.path) }
      next()
    }
  } else {
    if (isDevelopmentEnvironment) { console.log('No authorization required for ' + to.path) }
    next() // make sure to always call next()!
  }
})

export default router
